import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSelect, Layout, InputSwitch, InputPicklist } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './coa-model';  //editable..
import CoaList from './coa-list.component';
import CoabalanceList from '../coabalance/coabalance-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class CoaView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} 
                model={Model} onLoad={this.onLoad} disableCard>              

                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                        }
                        <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                        {this.state.datarow.parent &&
                        <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                        }
                    </>
                    },

                    {caption: 'Sub Account', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <CoaList history={this.props.history} root={this.props.root} caption='Sub Account' parentId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },

                    {caption: 'Balances', child:
                    this.state.datarow.id > 0 &&
                        <CoabalanceList history={this.props.history} root={this.props.root} coaId={this.state.datarow.id}  actions={['view']} disableBackButton disableCard/> 
                    }

                    ]}
                    
                />        

            </BaseView>
        );
    }
}